<template>
  <b-card class="bg-white rounded-xl px-4">
    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-semibold">List of Brands</h2>

        <small class="text-muted">Manage all your brand here. </small>
      </div>

      <base-button
        outline
        class="px-3 py-1 mx-1"
        type="primary"
        @click="handleOpen"
      >
        <span class="btn-inner--text flex justify-between items-center"
          ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon> Add
          Brand
        </span>
      </base-button>
    </div>
    <BrandTable ref="dataload" />
    <b-modal
      header-bg-variant="primary text-white"
      class="custmodaltitle"
      id="add-brand"
      title="Add Brand"
      hide-footer
    >
      <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
        <b-form role="form" @submit.prevent="handleSubmit(handleCreate)">
          <div class="mb-4">
            <p class="input-title text-black">Name</p>
            <base-input
              v-model="name"
              placeholder="Enter brand name"
              class="md:border-0 lg:border-0 custipshadow"
              name="Name"
              :rules="{ required: true }"
            ></base-input>
          </div>
          <div class="mb-4">
            <p class="input-title text-black">Email</p>
            <base-input
              v-model="email"
              placeholder="Enter email"
              class="md:border-0 lg:border-0 custipshadow"
              name="Email"
              :rules="{ required: true, email: true }"
            ></base-input>
            <span class="clr-red">*</span
            ><span class="fsize14 text-gray-400 pl-2"
              >Upon purchasing this brand product, the owner will receive an
              email, except affiliated products</span
            >
          </div>
          <div class="flex justify-center">
            <b-button
              class="font-semibold"
              type="primary"
              native-type="submit"
              variant="primary"
              >Save</b-button
            >
          </div>
        </b-form>
      </validation-observer>
    </b-modal>
  </b-card>
</template>

<script>
import BrandTable from "./components/BrandTable.vue";

export default {
  components: {
    BrandTable,
  },
  data() {
    return {
      name: "",
      email: "",
    };
  },
  methods: {
    handleOpen() {
      this.name = "";
      this.email = "";
      this.$bvModal.show("add-brand");
    },
    async handleCreate() {
      let payload = {
        name: this.name.trim(),
        email: this.email.trim(),
      };
      let loader = this.$loading();
      try {
        await this.$store.dispatch("affiliate/createBrand", payload);
        this.$refs.dataload.dataload();
        this.reset();
        loader.close();
      } catch (error) {
        loader.close();
        console.log(error);
      }
    },
    reset() {
      this.$bvModal.hide("add-brand");
      this.name = "";
      this.email = "";
    },
  },
};
</script>
<style>
.modal-title {
  color: white !important;
}
</style>
